// @flow

import commonPaths from "./commonPaths";

const getFooterLinks = (basename: string) => [
  {
    title: "Gender-Disclaimer",
    href: `${basename}${commonPaths.genderDisclaimer.substring(1)}`
  },
  {
    title: "Nutzungsbedingungen",
    href: `${basename}${commonPaths.termsAndConditions.substring(1)}`
  },
  {
    title: "Datenschutzerklärung",
    href: `${basename}${commonPaths.privacyPolicy.substring(1)}`
  },
  {
    title: "Impressum",
    href: `${basename}${commonPaths.legalNotice.substring(1)}`
  }
];

export default getFooterLinks;
